import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { faArrowLeft, faBars, faHome } from '@fortawesome/free-solid-svg-icons';
import { MenuController } from '../../node_modules/@ionic/angular';
import { fadeAnimation } from '../app/shared/animations/route-animations';
import { AuthenticationService } from './shared/services/authentification/authentification.service';
import { DataService } from './shared/services/data/data.service';
import { UserService } from './shared/services/user/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [fadeAnimation]

})
export class AppComponent implements OnInit {

  @ViewChild('drawer') public drawer: MatDrawer;

  faBars = faBars;
  faArrowLeft = faArrowLeft;
  faHome = faHome;

  date = new Date();

  constructor(
    public router: Router,
    private location: Location,
    private dataService: DataService,
    public menuCtrl: MenuController,
    private authService: AuthenticationService,
    private userService: UserService,
  ) { }

  ngOnInit(): void {

    const date = new Date(localStorage.getItem('bizz-ffv-token-exp'));
    const dateTokenExp = localStorage.getItem('bizz-ffv-token-exp');

    if (localStorage.getItem('bizz-ffv-rf-token')) {
      if (dateTokenExp && this.date > date) {
        this.authService.refreshToken().subscribe(() => {
          this.getMenu();
        });
      }
    }

    if (this.authService.currentUserValue === null) {
      this.dataService.isConnect.next(false);
    }

    this.getMenu();
  }

  goBack(): void {
    this.location.back();
  }

  private getMenu(): void {
    this.userService.getMenuUser().subscribe(res => {
      this.dataService.menu.next(res);
    });
  }

}


